// extracted by mini-css-extract-plugin
module.exports = {"brandLi":"BrandEntry_brandLi__bBQ0b","brandEntry":"BrandEntry_brandEntry__3Qzw7","accessibilityButton":"BrandEntry_accessibilityButton__7hxjZ"};